import { useEffect, useState } from "react";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { getRagCapabilities } from "../api/rag-api.js";
import type { ApiRagCapabilities, RagRetrievalMode } from "../api/types.js";

const AGENTIC_PREFERENCE_KEY = "rag-agentic-search";

let capabilitiesPromise: Promise<ApiRagCapabilities> | null = null;

function loadCapabilities(): Promise<ApiRagCapabilities> {
  if (!capabilitiesPromise) {
    capabilitiesPromise = getRagCapabilities().catch((error) => {
      capabilitiesPromise = null;
      throw error;
    });
  }
  return capabilitiesPromise;
}

export interface UseAgenticPreferenceResult {
  agentic: boolean;
  setAgentic: (value: boolean) => void;
  available: boolean;
  retrievalMode: RagRetrievalMode;
}

export function useAgenticPreference(): UseAgenticPreferenceResult {
  const [agentic, setAgentic] = useLocalStorage<boolean>(AGENTIC_PREFERENCE_KEY, true);
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadCapabilities()
      .then((capabilities) => {
        if (!cancelled) setAvailable(capabilities.agentic);
      })
      .catch(() => {
        if (!cancelled) setAvailable(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    agentic,
    setAgentic,
    available,
    retrievalMode: agentic ? "agentic" : "standard",
  };
}
